import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { PilotWhitelist, Waitlist } from '../beta-access.js';

/** Public ops: the email is user input, so it must match literally, not as a pattern (ReDoS / wildcard probing). */
const escapeRegExp = (value: string) =>
  Array.from(value, char => ('.*+?^${}()|[]\\'.includes(char) ? `\\${char}` : char)).join('');

export const checkWhitelistQuery = registerQuery({
  operationName: 'checkWhitelistQuery',
  type: () => Boolean,
  params: [{ name: 'email', type: () => String }],
  resolve: (email: string) => async () => {
    const whitelistCol = await getCollection(PilotWhitelist);
    const entry = await whitelistCol.findOne({ email: { $regex: new RegExp(`^${escapeRegExp(email)}$`, 'iv') } });
    return !!entry;
  },
});

export const joinWaitlistMutation = registerMutation({
  operationName: 'joinWaitlistMutation',
  type: () => Boolean,
  params: [{ name: 'email', type: () => String }],
  resolve: (email: string) => async () => {
    const waitlistCol = await getCollection(Waitlist);

    const existing = await waitlistCol.findOne({ email: { $regex: new RegExp(`^${escapeRegExp(email)}$`, 'iv') } });
    if (existing) return true;

    const waitlistDoc = new Waitlist({
      email: email.toLowerCase(),
      timestamp: new Date().toISOString(),
    });

    await waitlistCol.insertOne(waitlistDoc.toObject());
    return true;
  },
});
